import { defineMessages } from 'react-intl'

const messages = defineMessages({
  bookingPendingInformation: {
    id: 'voucher.pending-booking',
  },
  bookingPendingContactHotel: {
    id: 'booking.pending-contact',
  },
  yourPurchaseConfirmed: {
    id: 'voucher.your-purchase-confirmed',
  },
})

export default messages
